import * as React from 'react';
import { loadTheme } from 'office-ui-fabric-react';
import { Switch, Route, Redirect, RouteProps, Router } from "react-router-dom";
import './App.scss';
import { getStorage } from './lib/LocalStorageService';
import { IsAuthenticated } from './constants/GlobalConstants';

import Login from './components/account/login/Login';
import Dashboard from './components/admin/dashboard/Dashboard';
import ItemCategory from './components/admin/masters/itemcategory/ItemCategory';
import NewOrderBasicDetails from './components/admin/orders/neworder/NewOrderBasicDetails';
import NewOrderAddItems from './components/admin/orders/neworder/NewOrderAddItems';
import OrderHistory from './components/admin/orders/orderhistory/OrderHistory';
import { IAppProps } from './interfaces/IApp';
import Item from './components/admin/masters/item/Item';

import history from './lib/history';

export interface ProtectedRouteProps extends RouteProps {
  isAuthenticated: boolean;
  authenticationPath: string;
}

export function App(props: IAppProps) {
  const defaultProtectedRouteProps: ProtectedRouteProps = {
    isAuthenticated: (getStorage(IsAuthenticated) == "true"),
    authenticationPath: '/',
  };
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/">
          <Login />
        </Route>
        <ProtectedRoute
          {...defaultProtectedRouteProps}
          exact={true}
          path='/dashboard'
          component={Dashboard}
        />
        <ProtectedRoute
          {...defaultProtectedRouteProps}
          exact={true}
          path='/itemcategory'
          component={ItemCategory}
        />
        <ProtectedRoute
          {...defaultProtectedRouteProps}
          exact={true}
          path='/item'
          component={Item}
        />
        <ProtectedRoute
          {...defaultProtectedRouteProps}
          exact={true}
          path='/neworderbasicdetails'
          component={NewOrderBasicDetails}
        />
        <ProtectedRoute
          {...defaultProtectedRouteProps}
          exact={true}
          path='/neworderadditems'
          component={NewOrderAddItems}
        />
        <ProtectedRoute
          {...defaultProtectedRouteProps}
          exact={true}
          path='/orderhistory'
          component={OrderHistory}
        />
      </Switch>
    </Router>
  );
}

export class ProtectedRoute extends Route<ProtectedRouteProps> {
  public render() {
    let redirectPath: string = '';
    if (!this.props.isAuthenticated) {
      redirectPath = this.props.authenticationPath;
    }

    if (redirectPath) {
      const renderComponent = () => (<Redirect to={{ pathname: redirectPath }} />);
      return <Route {...this.props} component={renderComponent} render={undefined} />;
    } else {
      return <Route {...this.props} />;
    }
  }
}

export default App;

loadTheme({
  palette: {
    themePrimary: '#e61610',
    themeLighterAlt: '#fef5f5',
    themeLighter: '#fbd7d6',
    themeLight: '#f7b5b2',
    themeTertiary: '#f06e6a',
    themeSecondary: '#e9312a',
    themeDarkAlt: '#cf150e',
    themeDark: '#ae120c',
    themeDarker: '#810d09',
    neutralLighterAlt: '#f8f8f8',
    neutralLighter: '#f4f4f4',
    neutralLight: '#eaeaea',
    neutralQuaternaryAlt: '#dadada',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#595959',
    neutralSecondary: '#373737',
    neutralPrimaryAlt: '#2f2f2f',
    neutralPrimary: '#000000',
    neutralDark: '#151515',
    black: '#0b0b0b',
    white: '#ffffff',
  }
});